export const SIMPLE_EMAIL_VALIDATION: string = "simple-email-validation";

export const ADVANCED_EMAIL_VALIDATION: string = "advanced-email-validation";

